import { lazy } from "react";
import { registerSourceHelp } from "./SourceHelpRegistry";
import { SourceTypeIds } from "@onetasklist/shared/sources/source-settings";

export { ConnectionHelpPanel } from "./ConnectionHelpPanel";
export { getSourceHelpContent, getSourceHelpDocsUrl } from "./SourceHelpRegistry";
export type { SourceHelpContentProps } from "./SourceHelpRegistry";
export type { ConnectionHelpPanelProps } from "./ConnectionHelpPanel.ViewModel.types";

registerSourceHelp(SourceTypeIds.Jira, lazy(() => import("./JiraHelpContent")));
registerSourceHelp(SourceTypeIds.Trello, lazy(() => import("./TrelloHelpContent")));
registerSourceHelp(SourceTypeIds.Slack, lazy(() => import("./SlackHelpContent")));
registerSourceHelp(SourceTypeIds.GitHub, lazy(() => import("./GitHubHelpContent")));
registerSourceHelp(SourceTypeIds.Monday, lazy(() => import("./MondayHelpContent")));
registerSourceHelp(SourceTypeIds.Asana, lazy(() => import("./AsanaHelpContent")));
registerSourceHelp(SourceTypeIds.Salesforce, lazy(() => import("./SalesforceHelpContent")));
registerSourceHelp(SourceTypeIds.ClickUp, lazy(() => import("./ClickUpHelpContent")));
registerSourceHelp(SourceTypeIds.GoogleCalendar, lazy(() => import("./GoogleCalendarHelpContent")));
registerSourceHelp(SourceTypeIds.GoogleDrive, lazy(() => import("./GoogleDriveHelpContent")));
registerSourceHelp(SourceTypeIds.GoogleTasks, lazy(() => import("./GoogleTasksHelpContent")));
registerSourceHelp(SourceTypeIds.Confluence, lazy(() => import("./ConfluenceHelpContent")));
registerSourceHelp(SourceTypeIds.Gmail, lazy(() => import("./GmailHelpContent")));
registerSourceHelp(SourceTypeIds.GitLab, lazy(() => import("./GitLabHelpContent")));
registerSourceHelp(SourceTypeIds.MSProject4TW, lazy(() => import("./Project4TWHelpContent")));
registerSourceHelp(SourceTypeIds.MicrosoftPlanner, lazy(() => import("./PlannerHelpContent")));
registerSourceHelp(SourceTypeIds.OneNote, lazy(() => import("./OneNoteHelpContent")));
registerSourceHelp(SourceTypeIds.Notion, lazy(() => import("./NotionHelpContent")));
registerSourceHelp(SourceTypeIds.SharePoint, lazy(() => import("./SharePointHelpContent")));
registerSourceHelp(SourceTypeIds.Todoist, lazy(() => import("./TodoistHelpContent")));
registerSourceHelp(SourceTypeIds.OutlookMail, lazy(() => import("./OutlookMailHelpContent")));
registerSourceHelp(SourceTypeIds.OutlookTasks, lazy(() => import("./OutlookTasksHelpContent")));
registerSourceHelp(SourceTypeIds.OutlookCalendar, lazy(() => import("./OutlookCalendarHelpContent")));
registerSourceHelp(SourceTypeIds.Vsts, lazy(() => import("./VstsHelpContent")));
registerSourceHelp(SourceTypeIds.Altus, lazy(() => import("./AltusHelpContent")));
registerSourceHelp(SourceTypeIds.Cds, lazy(() => import("./CdsHelpContent")));
registerSourceHelp(SourceTypeIds.AltusLists, lazy(() => import("./CdsHelpContent")));
